import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import { mask } from "vue-the-mask";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "@mdi/font/css/materialdesignicons.css";
import Permissao from "@/shared/components/permissao.vue";

import "./plugins/vuetify-money.js";

Vue.config.productionTip = false;
Vue.component("v-permissao", Permissao);
Vue.directive("mask", mask);
// Vue.directive("permissao", Permissao);

new Vue({
  router,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
